import { DataSourceState } from "abweb/dto/generated/ds/DataSourceState";
import { DataSourceValueBooleanBase } from "abweb/dto/generated/ds/DataSourceValueBooleanBase";
import { DataSourceValue } from "abweb/dto/ds/DataSourceValue";
import { ClassUtils } from "abweb/utils/ClassUtils";
export class DataSourceValueBoolean extends DataSourceValueBooleanBase {
  static createWithReadOnlyDefaults(id, value, refID = null) {
    return DataSourceValueBoolean.createDataSourceValueBoolean(/*attributeValues*/null, /*clientTag*/null, /*dataSourceSaveAction*/null, id, /*baselineRef*/null, refID, DataSourceState.NORMAL, /*baseline*/null, value, /*editableOverwrite*/null, /*fieldTypeOverwrite*/null);
  }
  static createDataSourceValueBoolean(attributeValues, clientTag, dataSourceSaveAction, id, baselineRef, refID, state, baseline, value, editableOverwrite = null, fieldTypeOverwrite = null) {
    const retVal = new DataSourceValueBoolean();
    retVal.initDataSourceValueBoolean(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRef, fieldTypeOverwrite, refID, baseline, null, value);
    return retVal;
  }
  constructor() {
    super();
  }
  initDataSourceValueBoolean(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value) {
    super.initDataSourceValueBoolean(attributeValues, clientTag, dataSourceSaveAction, editableOverwrite, id, state, baselineRefID, fieldTypeOverwrite, refID, baseline, currentValue, value);
    if (currentValue == null) {
      this.currentValue = value;
    }
  }
  getCurrentValue() {
    return this.currentValue;
  }
  getValue() {
    return this.value;
  }
  getBaseline() {
    return this.baseline;
  }
  getDisplayValue() {
    return this.getFormattedValue(this.get("currentValue"));
  }
  getFormattedValue(value) {
    // TODO: i18n Yes/No?
    if (this.isRequired() || value != null) {
      return value ? "true" : "false";
    } else {
      return "undefined";
    }
  }
  get isBoolean() {
    return true;
  }
  coerceValue(value) {
    if (value == null) {
      return this.isRequired() ? false : null;
    }
    if (ClassUtils.isInstanceOf(value, DataSourceValue)) {
      if (value.isReference) {
        throw new Error("Cannot coerce a REFERENCE value to BOOLEAN");
      }
      value = value.getCurrentValue();
    }
    if (value == null) {
      return this.isRequired() ? false : null;
    }
    const t = typeof value;
    if (t === "boolean") {
      return value;
    }
    if (t === "string") {
      const s = value.toLowerCase();
      if (s === "true" || s === "yes") {
        return true;
      }
      if (s.length === 1) {
        const c = s.charAt(0);
        if (c === "t" || c === "y") {
          return true;
        }
      }
      if (s.length === 0) {
        return this.isRequired() ? false : null;
      }
      return false;
    }
    if (t === "number") {
      const n = value;
      return n !== 0;
    }
    throw new Error(`Cannot coerce ${value.toString()} to boolean`);
  }
  initializeWithDefaultFieldValue(field) {
    if (field.defaultValue == null) {
      return;
    }
    const defaultValue = this.coerceValue(field.defaultValue);
    this.value = this.currentValue = defaultValue;
  }
}
//# sourceMappingURL=DataSourceValueBoolean.js.map
